
import './App.css';
import Home from './components/home';
import Demo from './components/Demo';
import BuyPage from './components/main-app.js';
import Pay from './components/pay';
import Finalise from './components/finalise';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react';
import { WagmiConfig } from 'wagmi';
import { arbitrum } from 'wagmi/chains';

function App() {
  const projectId = "eb324622e7ea2c06edc615bf34b414ef";
  const metadata = {
    name: "blockIO",
  }

  const chains = [arbitrum];
  const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata });
  createWeb3Modal({ wagmiConfig, projectId, chains })

  return (
    <WagmiConfig config={wagmiConfig}>
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/demo' element={<Demo />} />
          <Route path='/buy' element={<BuyPage />} />
          <Route path='/pay' element={<Pay />} />
          <Route path='/finalise' element={<Finalise />} />
        </Routes>
      </div>
    </BrowserRouter>
    </WagmiConfig>
  );
}

export default App;
